import { render, staticRenderFns } from "./OrderStatusesFormInput.vue?vue&type=template&id=0c3895c2&scoped=true&"
import script from "./OrderStatusesFormInput.vue?vue&type=script&lang=js&"
export * from "./OrderStatusesFormInput.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatusesFormInput.vue?vue&type=style&index=0&id=0c3895c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3895c2",
  null
  
)

/* custom blocks */
import block0 from "./OrderStatusesFormInput.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports